import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2dc1524a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text"
}
const _hoisted_2 = { key: 1 }

import { ref, watch, onBeforeUnmount, onMounted } from "vue";

// Определяем пропсы с типами
interface Props {
  retryAfter: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'code-timer',
  props: {
    retryAfter: {}
  },
  setup(__props: any) {

const props = __props;

const codeTimer = ref<number>(0);
let timerInterval: any = null;

const startTimer = (retryAfterTimestamp: number) => {
  const currentTime = Math.floor(Date.now() / 1000); // Текущее время в секундах
  codeTimer.value = retryAfterTimestamp - currentTime;

  if (timerInterval !== null) {
    clearInterval(timerInterval);
  }

  timerInterval = setInterval(() => {
    if (codeTimer.value > 0) {
      codeTimer.value--;
    } else {
      codeTimer.value = 0;
      clearInterval(timerInterval);
      timerInterval = null; // Устанавливаем обратно в null
    }
  }, 1000);
};

watch(
  () => props.retryAfter,
  (newVal) => {
    if (newVal) {
      startTimer(newVal);
    }
  }
);

// Запуск таймера при монтировании, если retryAfter уже задан
onMounted(() => {
  if (props.retryAfter) {
    startTimer(props.retryAfter);
  }
});

onBeforeUnmount(() => {
  if (timerInterval !== null) {
    clearInterval(timerInterval);
  }
});

return (_ctx: any,_cache: any) => {
  return (codeTimer.value > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Запросить код повторно через " + _toDisplayString(codeTimer.value) + " секунд ", 1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ]))
}
}

})